export const SKIP = 'SKIP';
export const START = 'START';
export const REPORT_15 = 'REPORT_15';
export const DONE = 'DONE';

export default { DONE, REPORT_15, SKIP, START };
